import React from 'react';
import './Home.css';
import profilePhoto from './user-ai.jpg';
import { FaGithub, FaLinkedin } from 'react-icons/fa';

const Home = () => {
  return (
    <div>
      <div className="home-container" id="home">
        <div className="social-icons">
          <a href="https://github.com/ashishkr05" target="_blank" rel="noopener noreferrer">
            <FaGithub size={25} />
          </a>
          <a href="https://www.linkedin.com/in/ashish-kumar-b180821aa/" target="_blank" rel="noopener noreferrer">
            <FaLinkedin size={25} />
          </a>
        </div>
        <div className="content-container">
          <h1 className="title">Hi, I’m Ashish</h1>
          <h2>Software Developer</h2>
          <p>Detail-oriented software engineer with high-level experience in full-stack development and a passion for producing quality work through innovative solutions.</p>
          <a href="mailto:ashishbgs9783@gmail.com" className="contact-button">
            Contact Me <span className="arrow">&#10148;</span>
          </a>
        </div>
        <div className="image-container">
          <img src={profilePhoto} alt="Ashish Kumar" className="home-photo" />
        </div>
      </div>
    </div>
  );
}

export default Home;
